module.exports = __webpack_public_path__ + "assets/Icona_primi_menu_laterale.634e4e41.svg";